import DOMPurify from 'dompurify'
import MarkdownIt from 'markdown-it'

const mdWithHtml = new MarkdownIt({ html: true }) // MarkdownIt disables HTML by default

export function renderMarkdown(content) {
  return DOMPurify.sanitize(mdWithHtml.render(content))
}

export function renderInlineMarkdown(content) {
  return DOMPurify.sanitize(mdWithHtml.renderInline(content))
}
